import React, { useState } from 'react';
import css from './FilterSidebar.module.css';
import { useSelector } from 'react-redux';
import FilterSectionHeader from './FilterSectionHeader';
import SearchInput from './SearchInput';
import { customInterestsSelector } from '../SearchPage.duck';
const CustomInterestFilter = ({
  selectedValues = [],
  paramKey,
  handleClearFilter,
  handleCheckboxChange,
}) => {
  const customFilters = useSelector(customInterestsSelector);
  const [searchTerm, setSearchTerm] = useState('');
  // const interestKeyConfig = userFields.find(f => f.key === FieldConfigKey.INTEREST) || {};
  // const interestFilterOptions = createFilterOptions(interestKeyConfig.enumOptions) || [];

  // // Filter options based on the search term (case insensitive)
  const filteredInterests = customFilters.filter(opt =>
    opt.toLowerCase().includes(searchTerm.toLowerCase())
  );
  const handleClear = () => {
    handleClearFilter(paramKey);
    setSearchTerm('');
  };
  return (
    <div className={css.filterSection}>
      <FilterSectionHeader titleId={'FilterCategories.customInterest'} handleClear={handleClear} />

      {/* Search Input */}
      <SearchInput
        placeholder="Search custom interests..."
        value={searchTerm}
        onChange={e => setSearchTerm(e.target.value)}
      />
      <div className={css.scrollable}>
        {filteredInterests.map(opt => {
          const optionKey = opt;
          const isChecked = selectedValues.includes(optionKey);
          return (
            <label key={optionKey} className={css.checkboxLabel}>
              <input
                type="checkbox"
                value={opt}
                checked={isChecked}
                onChange={e => handleCheckboxChange(e, paramKey)}
                name="customInterests"
              />
              <span>{opt}</span>
            </label>
          );
        })}
      </div>
    </div>
  );
};

export default CustomInterestFilter;
